"use strict"

/**
 *	----------------------------------------------------------------------------------------------
 *	Imports
 * 	----------------------------------------------------------------------------------------------
 */
 import { Slim } from "slim-js";

/**
 *	----------------------------------------------------------------------------------------------
 *	Class AdmSlimDirectives - SlimJS Directives Extensions
 * 	----------------------------------------------------------------------------------------------
 */
class AdmSlimDirectives {

    add(type){
        switch(type){
            case "html": 
                // usage: <my-element bind.html=""></my-element>
                Slim.customDirective(
                    (attr) => {
                        return attr.nodeName === "bind.html"
                    },
                    (source, target, attribute, match) => {
                        const path = attribute.value;
                        Slim.bind(source, target, path, () => {
                            let data = Slim.lookup(source, path, target)
                            target.innerHTML = "";
                            target.innerHTML = data;
                        });		
                    }
                )
                break;
        }

    }
}

const slimDirectives = new AdmSlimDirectives()

export {slimDirectives, AdmSlimDirectives};